import React from "react";
import Scroll from "react-scroll";

const scroller = Scroll.scroller;

export function useScrollToAnchor(_anchor?: string) {
	React.useEffect(() => {
		setTimeout(() => {
			const hash = window.location.hash;
			const anchor = _anchor || hash.slice(1, hash.length);
			const appHeader = document.getElementsByClassName(
				"gik-app-header",
			)[0] as HTMLDivElement;
			scroller.scrollTo(anchor, {
				duration: 500,
				smooth: true,
				// containerId: 'ContainerElementID',
				offset: -appHeader?.offsetHeight,
			});
		}, 300);
	}, [_anchor]);

	return null;
}
